<div class="nova-font-style">
  <div class="top-margin-15"></div>
  <div class="row top-margin-15">
    <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3 bottom-padding-10" id="org-info">
      <h2>Organization Information</h2>
      <!-- Organization details -->
      <div class="top-margin-15"></div>
      <div *ngIf="orgInformation">
        <div class="row">
          <p class="headingrow" id="org-details"><span class="bold headingtext">Organization Details</span></p>
          <div class="row">
            <div class="col s12 m12 l12 xl6">
              <span id="org-name">
                <span class="bold">
                  Name:
                </span>
                {{orgInformation.name}}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col s12 m12 l12 xl12">
              <span id="org-address">
                <span class="bold">
                  Address:
                </span>
                {{ orgInformation.fullOrgName }}
              </span>
            </div>
          </div>
        </div>
        <!-- Location details -->
        <div class="top-margin-15"></div>
        <div *ngIf="orgInformation.locations && orgInformation.locations.length > 0">
          <div class="row">
            <p class="headingrow" id="location-details"><span class="bold headingtext">Locations Details</span></p>
            <div class="row">
              <div *ngFor="let loc of orgInformation.locations">
                <div class="col s12 m12 l8 xl8">
                  <span id="location-name">
                    <span class="bold">
                      Name:
                    </span>
                    <span class="left-margin-10">
                      {{loc.Name}}
                    </span>
                  </span>
                </div>
                <div class="col s12 m12 l4 xl4">
                  <span id="location-code">
                    <span class="bold">
                      Code:
                    </span>
                    <span class="left-margin-10">
                      {{loc.Code}}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Payment type details -->
        <div *ngIf="paymentType">
          <div class="top-margin-15"></div>
          <div class="row">
            <p class="headingrow"><span class="bold headingtext">Payment Type</span></p>
            <div class="row">
              <div class="col s12 m12 l12 xl12">
                <span>
                  <span class="bold">
                    Payment Type:
                  </span>
                  <span class="left-margin-10">
                    {{paymentType}}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-notification-loading></app-notification-loading>
</div>
